import { withStyles, Box } from 'vopay';
import { useHistory } from 'react-router-dom';
import { Title, UtilButton } from 'UI';
import ElinxSettingsForm from './ElinxSettingsForm';
import styles from './ElinxSettingsPage.module.scss';

const cn = withStyles(styles);

const ElinxSettingsPage = () => {
  const history = useHistory();

  return (
    <div className={cn('elinxSettingsPage')}>
      <UtilButton iconLeft="chevron_left" size="large" onClick={() => history.goBack()}>
        Back
      </UtilButton>
      <Box flx="col">
        <Title className={cn('title')}>eLinx Settings</Title>
        <ElinxSettingsForm onClose={() => history.goBack()} />
      </Box>
    </div>
  );
};

export default ElinxSettingsPage;
